import React from 'react';
import Slider from './Slider';
import Scrollable from './Scrollable';

export default ({ data=[] }) => (
  <section className='Hero-Header-Section'>
    <Slider data={data}/>
    <Scrollable data={data}/>
  </section>
);
